//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { EmailReportTopic } from '@account-settings/redux/emailReports/emailReportsConstants';
import { IReportContent } from '@account-settings/redux/emailReports/emailReportsModel';

export const displayReportContent = (
  reportContent: IReportContent,
  isDeleting?: boolean,
): string => {
  const res = [];
  if (reportContent.curalateExperiences) {
    res.push('Vibe Commerce Experiences');
  }
  if (reportContent.instagramInsights) {
    res.push('Instagram Insights');
  }
  if (reportContent.facebookInsights) {
    res.push('Facebook Insights');
  }
  if (reportContent.tiktokInsights) {
    res.push('TikTok Insights');
  }
  if (isDeleting) {
    return res.length > 2
      ? `${res[0] ?? ''}, ${res[1] ?? ''}, and ${res[2] ?? ''}`
      : res.join(' and ');
  }

  return res.join(', ');
};

export const displayTopic = (topic: string): string => {
  return topic === EmailReportTopic.INSIGHTS_WEEKLY ? 'Weekly' : 'Monthly';
};

export const mapStringToTopic = (topic: string): EmailReportTopic => {
  return topic === EmailReportTopic.INSIGHTS_WEEKLY
    ? EmailReportTopic.INSIGHTS_WEEKLY
    : EmailReportTopic.INSIGHTS_MONTHLY;
};
